let toastInstance = null;

export function showLoadingEventToast(vm, options = { duration: 10000 }) {
    if (toastInstance) return toastInstance;
    if (!vm.$toasted) return null;
    toastInstance = vm.$toasted.info('Wait! Loading your event…', options);

    return toastInstance;
}

export function hideLoadingEventToast() {
    if (!toastInstance) return;
    toastInstance.goAway(0);
    toastInstance = null;
}



// WEBPACK FOOTER //
// ./src/utils/loadingEventToast.js